<template>
  <v-row>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1 font-weight-bold">{{ titreMotif }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea
              name="input-7-1"
              filled
              auto-grow
              v-model="motif"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-center">
            <v-btn class="mx-2 primary" @click="continuerMotif">
              <v-icon left>save</v-icon>
              Continuer
            </v-btn>
            <v-btn class="mx-2 normal" @click="annulerMotif">
              <v-icon left>mdi-close</v-icon>
              Annuler
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <BaseBlock v-if="!loading.display" :title="titre">
        <ResumeCandidature
          v-if="candidature.id"
          :candidature="candidature"
          :voirTypeEtudiant="true"
        ></ResumeCandidature>

        <v-row cols="12" justify="center">
          <div class="text-center">
            <ButtonConfirmation
              v-if="candidature.etatDemande.id == ETAT.VALIDATION_SUAIO.code"
              :inactif="loadingBtn"
              icone="mdi-check-bold"
              libelle="Valider"
              title="Le dossier est acceptable, il est transmis à la composante"
              @ok="valider"
            ></ButtonConfirmation>
            <v-btn
              v-if="candidature.etatDemande.id == ETAT.VALIDATION_SUAIO.code"
              class="ma-2"
              color="primary"
              title="Vous rejetez la candidature. L'étudiant n'a pas été accompagné (atelier ou entretien)"
              @click="saisieMotifNonValide"
              :loading="loadingBtn"
            >
              <v-icon left>mdi-card-bulleted-off</v-icon>Candidature non
              recevable
            </v-btn>
            <v-btn
              v-if="candidature.etatDemande.id == ETAT.VALIDATION_SUAIO.code"
              class="ma-2"
              color="primary"
              title="Le dossier est à compléter. Vous le retournez à l'étudiant"
              @click="saisieMotifRenvoyer"
              :loading="loadingBtn"
            >
              <v-icon left>mdi-account-arrow-left</v-icon>Autoriser la
              rectification
            </v-btn>
            <ButtonConfirmation
              v-if="candidature.etatDemande.id == ETAT.NON_VALIDE.code"
              :inactif="loadingBtn"
              icone="mdi-step-backward"
              libelle="Revenir sur le rejet"
              title="La candidature est replacée dans l'état 'en attente de validation par le SUAIO'"
              @ok="repentir"
            ></ButtonConfirmation>
            <router-link
              :to="{
                name: 'listing-suaio',
                params: {
                  idFormation: candidature.formation.id,
                  idCampus: idCampus
                }
              }"
            >
              <v-btn class="ma-2" color="primary">Retour</v-btn>
            </router-link>
          </div>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import ResumeCandidature from "@/components/ResumeCandidature";
import ButtonConfirmation from "@/components/ButtonConfirmation";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import { mapState } from "vuex";

export default {
  name: "DetailCandidatureSuaio",
  props: ["idCandidature", "idCampus"],
  mixins: [EtatDemande],
  components: { BaseBlock, ResumeCandidature, ButtonConfirmation },
  data() {
    return {
      loadingBtn: false,
      candidature: {
        id: "",
        etudiant: {},
        formation: {},
        etatDemande: {},
        bacSerie: ""
      },
      dialog: false,
      actionMotif: "",
      motif: ""
    };
  },
  methods: {
    async getCandidature() {
      //await new Promise(r => setTimeout(r, 2000));
      try {
        const candidature = await ApiCandidatureRepository.getCandidature(
          this.idCandidature
        );
        this.candidature = candidature;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.$store.commit("setEcranChargement", false);
      }
    },
    retourListing() {
      this.$router.push({
        name: "listing-suaio",
        params: {
          idFormation: this.candidature.formation.id,
          idCampus: this.idCampus
        }
      });
    },
    async valider() {
      this.loadingBtn = true;
      try {
        await ApiCandidatureRepository.validerCandidatureSuaio(
          this.idCandidature
        );
        this.$toast.info("La candidature a été validée.");
        this.retourListing();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
      }
    },
    async invalider() {
      this.loadingBtn = true;
      try {
        await ApiCandidatureRepository.invaliderCandidature(
          this.idCandidature,
          this.motif
        );
        this.$toast.info(
          "La candidature a été déclarée non valide. Une notification par mail lui a été adressée."
        );
        this.retourListing();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
        this.motif = "";
      }
    },
    async renvoyer() {
      this.loadingBtn = true;
      try {
        await ApiCandidatureRepository.renvoyerCandidature(
          this.idCandidature,
          this.motif
        );
        this.$toast.info(
          "La candidature a été renvoyée à l'étudiant. Une notification par mail lui a été adressée."
        );
        this.retourListing();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
        this.motif = "";
      }
    },
    async repentir() {
      this.loadingBtn = true;
      try {
        await ApiCandidatureRepository.repentirCandidatureSuaio(
          this.idCandidature
        );
        this.$toast.info("Vous pouvez à nouveau étudier cette candidature.");
        this.retourListing();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
      }
    },
    saisieMotifNonValide() {
      this.actionMotif = "nonValide";
      this.dialog = true;
    },
    saisieMotifRenvoyer() {
      this.actionMotif = "renvoyer";
      this.dialog = true;
    },
    continuerMotif() {
      this.dialog = false;
      if (this.motif === "") {
        if (this.actionMotif === "renvoyer") {
          this.$toast.error(
            "Vous devez indiquer la cause du retour du dossier de candidature"
          );
        } else {
          this.$toast.error("Vous devez motiver votre décision");
        }
      } else {
        if (this.actionMotif === "nonValide") {
          this.invalider();
        } else {
          this.renvoyer();
        }
      }
      this.actionMotif = "";
    },
    annulerMotif() {
      this.dialog = false;
      this.actionMotif = "";
      this.motif = "";
    }
  },
  computed: {
    ...mapState(["loading"]),
    titre() {
      return `Candidature de ${this.candidature.etudiant.nom} ${this.candidature.etudiant.prenom} à la formation ${this.candidature.formation.libelle}`;
    },
    titreMotif() {
      let titre;
      if (this.actionMotif === "renvoyer") {
        titre = "Veuillez saisir la raison du retour du dossier";
      } else if (this.actionMotif === "nonValide") {
        titre =
          "Veuillez saisir la raison du rejet du dossier pour cause de non-validité";
      }
      return titre;
    }
  },
  async created() {
    this.$store.commit("setEcranChargement", true);
    this.getCandidature();
  }
};
</script>
